import { PlusIcon, MinusIcon } from "@heroicons/react/24/outline"
import React, { useState, useRef, useEffect } from "react"

import Container from "./Container"

const FAQSection = ({ section, theme }) => {
  const [expanded, setExpanded] = useState({})
  const [animatingItems, setAnimatingItems] = useState({})
  const timeoutRefs = useRef({})

  // Get FAQ data from section settings or use empty array
  const faqItems = section?.settings?.faqs || []

  // Get section settings
  const settings = section?.settings || {}
  const showBackgroundColor = settings.showBackgroundColor || false
  const backgroundColor = showBackgroundColor ? settings.backgroundColor || theme?.colors?.secondary || "#F3F4F6" : null

  useEffect(
    () => () => {
      Object.values(timeoutRefs.current).forEach(clearTimeout)
    },
    []
  )

  const handleToggle = (question) => {
    setExpanded((prev) => {
      const newExpanded = { ...prev, [question]: !prev[question] }
      if (!newExpanded[question]) {
        setAnimatingItems((prev) => ({ ...prev, [question]: true }))
        timeoutRefs.current[question] = setTimeout(() => {
          setAnimatingItems((prev) => ({ ...prev, [question]: false }))
        }, 300)
      }
      return newExpanded
    })
  }

  // Don't render if no FAQs
  if (!faqItems || faqItems.length === 0) {
    return null
  }

  return (
    <div className="relative pb-36 pt-12" style={backgroundColor ? { backgroundColor } : {}}>
      {/* gradients - only show if no background color */}
      {!backgroundColor && (
        <>
          <div className="absolute top-[-20px] aspect-square w-1/2 rounded-full bg-gradient-to-b from-[#8ab4ff] to-[#e0faff] opacity-20 blur-[200px] min_lg:left-[430px]" />
          <div className="absolute top-[133px] aspect-square w-1/2 rounded-full bg-[#0093ff] opacity-20 blur-[200px] min_lg:left-[482px]" />
        </>
      )}

      <Container>
        <img
          loading="lazy"
          src="/images/practitioner-landing/graphics/lp-elements/faqs.jpg"
          alt="FAQ"
          className="absolute right-[-86px] top-[-130px] w-[505px] rounded-lg shadow-landingPage lg:static lg:mb-32 lg:w-full lg:shadow-landingPageMobile"
        />
        <div className="flex flex-col gap-10 lg:gap-8">
          <div className="text-[32px] font-extrabold">{section?.headline || "Frequently Asked Questions"}</div>
          {faqItems.map((item, index) => (
            <div key={index}>
              <div
                className="flex cursor-pointer items-center gap-1 lg:items-start"
                onClick={() => handleToggle(item.question)}>
                {expanded[item.question] || animatingItems[item.question] ? (
                  <MinusIcon className="h-6 w-6 flex-none text-teal lg:mt-0.5" />
                ) : (
                  <PlusIcon className="h-6 w-6 flex-none text-teal lg:mt-0.5" />
                )}
                <div className="text-[22px] hover:text-teal lg:text-lg">{item.question}</div>
              </div>
              <div
                className={`mt-2 overflow-hidden transition-all duration-300 ease-in-out ${
                  expanded[item.question] ? "max-h-16 lg:max-h-28" : "max-h-0"
                }`}>
                <p className="ml-[28px] text-gray-dark lg:text-sm">{item.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </Container>
    </div>
  )
}

export default FAQSection
